module.exports = __webpack_public_path__ + "static/media/old_bg_small.9fbcf5c7.png";